import {
  AverageLimit,
  AveragePlayerScore,
} from '#src/__generated__/globalTypes.ts';

import { useDefaultAverageScore } from './useDefaultAverageScore';

export const useDefaultAverageLimit = () => {
  const defaultAverageScore = useDefaultAverageScore();
  return defaultAverageScore ===
    AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE
    ? AverageLimit.LAST_10
    : AverageLimit.LAST_15;
};
